// export const SERVER_URL = "http://127.0.0.1:4900/api/v1";
// export const SERVER_URL = "https://staging_farm_backend.traceup.rw/api/v1";
export const SERVER_URL = "https://farm_backend.traceup.rw/api/v1";